import { render, staticRenderFns } from "./ed-homework-teacher-section-person.vue?vue&type=template&id=85e7577a&scoped=true&"
import script from "./ed-homework-teacher-section-person.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-teacher-section-person.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-teacher-section-person.scss?vue&type=style&index=0&id=85e7577a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e7577a",
  null
  
)

export default component.exports